import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { DeleteTariffModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/inputs/tariff/delete-tariff.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useDeleteTariffContext } from '../../tariff.context';
import { TariffDeleteFormStep1Controller } from '../tariff-delete-form-step-1/tariff-delete-form-step-1.controller';

export interface TariffDeleteFormControllerProps {
  onError: SubmitErrorHandler<Pick<DeleteTariffModel, 'id'>>;
  onSubmit: SubmitHandlerWithDirtyFields<Pick<DeleteTariffModel, 'id'>>;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const TariffDeleteFormController = (
  props: TariffDeleteFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const data = useDeleteTariffContext();

  return (
    <MultiStepFormProvider<Pick<DeleteTariffModel, 'id'>>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          fields: ['id'],
          component: <TariffDeleteFormStep1Controller />,
        },
      ]}
    />
  );
};
